import { VIEW_BORDER_RADIUS } from "@/constants/Styles";
import { colorResolver } from "@/helper/Color";
import { isJSON } from "@/helper/Json";
import { resolveBreakpointStyle } from "@/helper/Resolver";
import isEmpty from "lodash/isEmpty";
import isNumber from "lodash/isNumber";
import isString from "lodash/isString";
import { Dimensions, Platform } from "react-native";
import { COLOR_TYPES, CASTER, TYPES } from "./types";

export const handleProps = (props, width, height) => {
    const {
        style:propStyles = {},
        rounded = null,
        zIndex = null,
        position = null,
        xs = null,
        sm = null, 
        md = null,
        lg = null,
        xl = null,
        vw = null,
        vh = null,
        borderRadius = null,
        colorScheme = 'light',
        ...rest
    } = props;

    const styleProps = [];

    if (Array.isArray(propStyles)) {
        styleProps.push(...propStyles);
    } else if (!isEmpty(propStyles)) {
        styleProps.push(propStyles);
    }

    for (const key in rest) {

        if (TYPES.includes(key)) {

            let propKey = key;
            
            if (CASTER[key])
                propKey = CASTER[key];
            
            if (isJSON(rest[key])) {
                styleProps.push(resolveBreakpointStyle(propKey, rest[key]));
                continue;
            }

            if (COLOR_TYPES.includes(key) && rest[key]) {
                const resolvedColorCode = colorResolver({
                    color: rest[key], 
                    type: colorScheme, 
                    colorName: propKey == 'color' ? 'text' : 'background'
                });

                styleProps.push({[propKey]: resolvedColorCode});
                continue;
            }

            styleProps.push({[propKey]: rest[key]});
        

        }
    }

    if (rounded != null) {
        if (rounded === true)
            styleProps.push({borderRadius: VIEW_BORDER_RADIUS});

        if (isNumber(rounded)) 
            styleProps.push({borderRadius: rounded});

        if (rounded === 'full' || borderRadius === 'full') 
            styleProps.push({borderRadius: 5000});
    }
    if (isString(position)) 
        styleProps.push({position});

    if (vw === true)
        styleProps.push({width: Dimensions.get('window').width});
    
    if (vh === true)
        styleProps.push({height: Dimensions.get('window').height});
    
    if (isNumber(zIndex)) {

        styleProps.push({zIndex});

        if (Platform.OS === 'android')
            styleProps.push({elevation: zIndex});
    }


    return styleProps;
};